/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { CardList } from 'components/cards';

@observer
class SidePaneContent extends Component {

	render() {
		const {
			cardListVM,
			dndManager
		} = this.props;

		return (
			<div className="sidePane__content">
				<CardList
					handlers={{
						getContextMenuItems: cardListVM.getContextMenuItems
					}}
					cardListVM={cardListVM}
					cardActions={cardListVM.exploreVM.cardActions}
					onContextMenuToggle={this.onContextMenuToggle}
					onContextMenuChange={this.props.onContextMenuChange}
					onDelete={this.props.onDelete}
					dndManager={dndManager}
				/>
			</div>
		);
	}

	// Events

	onContextMenuToggle = (cardId, toggle) => {
		const { cardListVM } = this.props;
		if (toggle) {
			cardListVM.showContextMenu([cardId]);
		} else {
			cardListVM.clearContextMenu();
		}
	}
}

SidePaneContent.propTypes = {
	cardListVM: PropTypes.object.isRequired,
	dndManager: PropTypes.object.isRequired,
	onContextMenuChange: PropTypes.func,
	onDelete: PropTypes.func
};

SidePaneContent.defaultProps = {
	onContextMenuChange: () => {},
	onDelete: () => {}
};

export default SidePaneContent;



// WEBPACK FOOTER //
// ./src/js/components/cards/SidePaneContent.js